import { Button, Divider, Grid, Image, Modal, RemoveScroll, ScrollArea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { showNotification } from '../../utils/Notification/Notification';
import { useGetStoreImages } from '../../hooks/stores/queries';
import LoaderOverlay from '../../components/LoaderOverlay/LoaderOverlay';
import { IconCheck } from '@tabler/icons-react';
import classes from './Products.module.css';
import { IStoreImage } from '../../interfaces/StoreImage';

export default function SelectProductImageModal({
  opened,
  close,
  storeId,
  form
}: {
  form: any;
  opened: boolean;
  close: () => void;
  storeId: string;
}) {
  const { t } = useTranslation(['Notifications', 'CommonButtons', 'ProductsPage']);
  const [selected, setSelected] = useState<IStoreImage>({
    _id: '',
    createdBy: '',
    name: '',
    createdDate: new Date()
  });
  const { isLoading: isGetStoreImagesLoading, data: storeImages } = useGetStoreImages(
    opened,
    storeId
  );
  const onSubmit = async () => {
    try {
      if (selected._id && selected.name) {
        form.setFieldValue('image', selected._id);
        form.setFieldValue('imageName', selected.name);
      } else {
        form.setFieldValue('image', '');
        form.setFieldValue('imageName', '');
      }
    } catch (e) {
      showNotification({ type: 'Error', title: t('Notifications:somethingWrong') });
    } finally {
      close();
    }
  };

  const onRemoveImage = () => {
    try {
      setSelected({
        _id: '',
        createdBy: '',
        name: '',
        createdDate: new Date()
      });
      form.setFieldValue('image', '');
      form.setFieldValue('imageName', '');
    } catch (e) {
      showNotification({ type: 'Error', title: t('Notifications:somethingWrong') });
    } finally {
      close();
    }
  };
  if (isGetStoreImagesLoading) return <LoaderOverlay visible />;

  console.log('[INFO] Rendering ProductModal');
  return (
    <Modal
      opened={opened}
      onClose={close}
      className={RemoveScroll.classNames.fullWidth}
      title={t('ProductsPage:selectImage')}
      scrollAreaComponent={ScrollArea.Autosize}>
      <Grid>
        {storeImages?.map((imgObj) => {
          return (
            <Grid.Col
              span={'auto'}
              key={imgObj._id}
              className={`${classes.imageWrapper} ${
                selected?._id === imgObj._id ? classes.imageSelected : ''
              }`}>
              <Image
                w={70}
                h={70}
                p={5}
                className={classes.imagePreview}
                onClick={() => setSelected(imgObj)}
                src={imgObj.resourceUrl}
                alt={imgObj.name}
              />
              {selected?._id === imgObj._id ? (
                <IconCheck color="white" className={classes.checkedIcon} />
              ) : null}
            </Grid.Col>
          );
        })}
        <Grid.Col
          span={12}
          style={{
            position: 'sticky',
            bottom: 0
          }}>
          <Grid>
            <Grid.Col span={{ xs: 12, md: 6 }}>
              <Button onClick={onRemoveImage} fullWidth color="gray">
                {t('CommonButtons:remove')}
              </Button>
            </Grid.Col>
            <Grid.Col span={{ xs: 12, md: 6 }}>
              <Button fullWidth onClick={onSubmit}>
                {t('CommonButtons:select')}
              </Button>
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
    </Modal>
  );
}
